var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.taskToPass)?_c(_vm.getTaskDetailComponent(),{tag:"component",attrs:{"passedTask":_vm.taskToPass}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }